import { createAction } from 'typesafe-actions';

import { RSState } from '../types';

export const patchRS = createAction('rs/patch_rs')<Partial<RSState>>();
